import moment from 'moment'

const DATE_FORMATS = {
  DATE: 'DD/MM/YYYY',
  DATE_ISO: 'YYYY-MM-DD',
  DATE_HOUR: 'DD/MM/YYYY H:mm',
  HOUR: 'H:mm:ss',
}

const monthDifference = (startDate: Date, endDate: Date): number => {
  return moment(endDate)
    .startOf('day')
    .diff(moment(startDate).startOf('day'), 'months', true)
}

const format = (date: Date, dateFormat: string = DATE_FORMATS.DATE) =>
  moment(date).format(dateFormat)

const formatString = (
  date: string,
  formatFrom: string | string[] = DATE_FORMATS.DATE,
  formatTo: string = DATE_FORMATS.DATE_ISO,
) => moment(date, formatFrom, true).format(formatTo)

const isToday = (date: Date) => {
  return moment().isSame(date, 'day')
}

const POSSIBLE_DATE_FORMATS = [
  'YYYYMMDD',
  'YYYY-MM-DD',
  'DD/MM/YYYY',
  'DD/MM/YY',
  'D/MM/YYYY',
  'D/M/YYYY',
  'D/M/YY',
]

export const DateUtils = {
  monthDifference,
  format,
  formatString,
  isToday,
  POSSIBLE_DATE_FORMATS,
}
